
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
// import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// import * as moment from 'moment';
import * as service from '../../services/service';

function SponsorshipCertificate() {
    const [state, setState] = useState({ filename: '', filepath: '', certificatenumber: '', outwardnumber: '', certificateid: '0' });
    // const [certificateFile, setCertificateFile] = useState('');
    const [issueDate, setIssueDate] = useState(new Date());    
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);        
    const navigate = useNavigate();
    const params = useParams();
    
    const getCertificateNumber = (date) => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_SPONSORSHIP_CERTIFICATE_NUMBER,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({                       
                        IssueDate: new Date(date).toUTCString(),                        
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        setState({
                            ...state, certificatenumber: result.message
                        });
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    };

    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_SPONSORSHIP_CERTIFICATE_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        SponsorshipId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, filename: result.fileName, filepath: result.filePath,
                            certificatenumber: result.certificateNumber, outwardnumber: result.outwardNumber,
                            certificateid: result.sponsorshipCertificateId
                        });
                        setIssueDate(new Date(result.issueDate));                        
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            // getRegistrationById();
            getDetailsById();
        }
    }, []);

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const IssueDateHandler = (date) => {
        setIssueDate(date);
        getCertificateNumber(date);
    };

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {                  
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const backHandler = () => {
        navigate('/sponsorships');
    };

    const generateCertificateHandler = () => {
        if (!state.certificatenumber) {
            // eslint-disable-next-line
            alert("Invalid Certificate Number");
        }
        else {
            sessionStorage.setItem('CertificateNumber', JSON.stringify(state.certificatenumber));            
            sessionStorage.setItem('IssueDate', JSON.stringify(issueDate));
            sessionStorage.setItem('OutwardNumber', JSON.stringify(state.outwardnumber));
            sessionStorage.setItem('CertificateId', JSON.stringify(state.certificateid));
            navigate(`/generatesponsorshipcertificate/${params.id}`);
        }
    };

    // function getExtension(filename) {
    //     return filename.split('.').pop()
    // }

    // const saveCertificateHandler = e => {
    //     if (!state.certificatenumber) {
    //         // eslint-disable-next-line
    //         alert("Invalid Certificate Number");
    //     }
    //     else if (!certificateFile) {
    //         // eslint-disable-next-line      
    //         alert("Please upload file");
    //     }
    //     else if (certificateFile && getExtension(certificateFile.name).toLowerCase() !== 'pdf') {
    //         // eslint-disable-next-line
    //         alert("Please upload pdf file");
    //     }
    //     else {
    //         e.preventDefault();
    //         const errs = {};
    //         setLoading(true);

    //         const formData = new FormData();
    //         formData.append("NFLSRegistrationId", params.id);
    //         formData.append("NFLSCertificateId", state.certificateid);
    //         formData.append("IssueDate", (new Date(issueDate)).toUTCString());
    //         formData.append("ValidFrom", (new Date(validFromDate)).toUTCString());
    //         formData.append("ValidTill", (new Date(validTillDate)).toUTCString());
    //         formData.append("CertificateNumber", state.certificatenumber);
    //         formData.append("OutwardNumber", state.outwardnumber);
    //         formData.append("CertificateFile", certificateFile);
    //         formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
    //         fetch(
    //             service.ADD_UPDATE_NFLS_CERTIFICATE,
    //             {
    //                 method: 'POST',
    //                 body: formData
    //             })
    //             .then(res => res.json())
    //             .then(result => {
    //                 if (result.messageType === 'Success') {
    //                     // eslint-disable-next-line
    //                     alert(result.message);
    //                     sessionStorage.setItem('CertificateNumber', null);
    //                     sessionStorage.setItem('ValidFrom', null);
    //                     sessionStorage.setItem('ValidTill', null);
    //                     sessionStorage.setItem('IssueDate', null);
    //                     sessionStorage.setItem('OutwardNumber', null);
    //                     sessionStorage.setItem('CertificateId', null);
    //                     navigate('/nflsregistrations');
    //                 }
    //                 else if (result.messageType === 'Failed') {
    //                     // eslint-disable-next-line
    //                     alert(result.message);
    //                     sessionStorage.setItem('CertificateNumber', null);
    //                     sessionStorage.setItem('ValidFrom', null);
    //                     sessionStorage.setItem('ValidTill', null);
    //                     sessionStorage.setItem('IssueDate', null);
    //                     sessionStorage.setItem('OutwardNumber', null);
    //                     sessionStorage.setItem('CertificateId', null);
    //                     navigate('/nflsregistrations');
    //                 }
    //                 else {
    //                     errs[".invalid"] = result.message.message;
    //                     setErrors(errs);
    //                 }
    //             });
    //         setLoading(false);
    //     }
    // };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">                                        
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <div style={{ fontWeight: 'bold' }}>Issue Date</div>
                                            <DatePicker
                                                id="issueDate"
                                                selected={issueDate}
                                                onChange={date => IssueDateHandler(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                                disabled={state.certificateid !== '0'}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".issueDate"]}</div>
                                        </MDBox>
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <div style={{ fontWeight: 'bold' }}>Outward Number</div>
                                            <MDInput fullWidth value={state.outwardnumber || ''}
                                                name="outwardnumber"
                                                onChange={changeHandler}
                                                id="outwardnumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".outwardnumber"]}</div>
                                        </MDBox>
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <div style={{ fontWeight: 'bold' }}>Certificate Number</div>
                                            <MDInput fullWidth value={state.certificatenumber || ''}
                                                name="certificatenumber"
                                                onChange={changeHandler}
                                                id="certificatenumber"                                                
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".certificatenumber"]}</div>
                                        </MDBox>
                                        {/* <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <div style={{ fontWeight: 'bold' }}>Upload Certificate (File Size 5 MB)</div>
                                            <TextField
                                                id="certificateFile"
                                                type="file"
                                                onChange={ev => setCertificateFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".certificateFile"]}</div>
                                        </MDBox> */}
                                        {state.filename ?
                                            <MDButton onClick={() => handleDownload(state.filename, state.filepath)}>{state.filename}</MDButton>
                                            : null}
                                        <Table>
                                            <TableRow>
                                                <TableCell>
                                                    {loading ? <Oval
                                                        heigth="20"
                                                        width="20"
                                                        color='grey'
                                                        ariaLabel='loading'
                                                    /> :
                                                        <MDButton color="info" onClick={generateCertificateHandler}>
                                                            Generate Certificate
                                                        </MDButton>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <MDButton color="secondary" onClick={backHandler}>
                                                        Back
                                                    </MDButton>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default SponsorshipCertificate;